import * as React from "react"
import Layout from "../components/layout"
import Header from "../components/header"
import SEO from "../components/seo"
import MSqr from "../components/mSqr.js"
import Footer from "../components/footer"
import { StaticImage } from "gatsby-plugin-image"
import Loader from "../components/Loader"
import Section100 from "../components/Section100"
import { navigate } from "gatsby-link"
import RentalForm from "../components/rentalForm"

class IndexPage extends React.Component {
	constructor(props) {
		super(props)
		this.state = {
			index: 0,
			timer: null,
			loaded: 0,
			interval: null,
			text: "Register",
			mobile: true,
			fromPrivacy: false,
			textTop: "01 WHERE HOME MATTERS",
			dwell: false,
			formType: "sales",
		}
		this.handleLink = this.handleLink.bind(this)
		this.submit = this.submit.bind(this)
	}

	submit = e => {
		e.preventDefault()
		let myForm = document.querySelector("form")
		let formData = new FormData(myForm)
		formData.append("dwell", this.state.dwell)

		fetch("/", {
			method: "POST",
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
			body: new URLSearchParams(formData).toString(),
		})
			.then(() => navigate("/thank-you/"))
			.catch(error => alert(error))
	}

	componentDidMount = () => {
		if (window.location.hash === "#dwell") {
			this.setState({ dwell: true })
		}

		if (window.innerWidth > 768 && window.innerHeight > 700) {
			this.setState({ mobile: false }, () => {
				this.setState({ text: "Register your Interest" })
				const scrollProgress = document.body.scrollTop
				const sectionHeight = window.innerHeight
				const currentSection = scrollProgress / sectionHeight

				if (currentSection > 0) {
					document.body.scrollTop = 0
				}
				this.setState({ index: 0 })

				this.setState({ text: "Register your Interest" })
				const html = document.querySelector("html")
				html.style.overflow = "hidden"
				const body = document.querySelector("body")
				body.style.overflow = "hidden"
			})
		} else {
			const body = document.querySelector("body")
			const html = document.querySelector("html")
			body.style.height = "auto"
			body.style.overflow = "auto"
			html.style.overflow = "auto"
			html.style.height = "auto"
		}

		//loading function called
		this.loading()
		setTimeout(() => {
			//main content loaded after 4s

			const loader = document.querySelector("#loader")
			loader.classList.add("loaded")

			//reveals register button on top left chnages fill of logo
			const register = document.querySelector("#register")
			register.classList.remove("hidden")
			const middleText = document.querySelector("#middle-text")

			middleText.classList.replace("o-p-0", "p-1")
			setTimeout(() => {
				middleText.classList.replace("tran-2-s", "p-5-t")
			}, 1000)

			//logo.classList.replace("inital-white", "fill-dark-putty")

			//loadingBar.classList.replace("white", "dark-putty")

			// enables scrolling after 0.5s
			if (!this.state.mobile) {
				setTimeout(() => {
					window.addEventListener(
						"wheel",
						e => {
							this.checkScrollDirection(e)
						},
						{ once: true }
					)
				}, 1000)
			}
		}, 4250)
	}

	handleLink = () => {
		const arrow = document.querySelector("#arrow")

		if (!this.state.mobile) {
			if (this.state.index !== 6) {
				this.setState({ index: 6 }, () => {
					const scroll = document.querySelector(".scrollWrapper")
					scroll.style.transform = `translateY(-${100 * this.state.index}vh)`
					document.querySelector("#top-button").classList.replace("p-1", "p-0")
					setTimeout(() => {
						this.setState({ text: "back to top" })
						arrow.classList.add("top")
						document.querySelector("#top-button").classList.replace("p-0", "p-1")
					}, 1000)
					const middle = document.querySelector("#middle-text")
					middle.classList.replace("p-1", "p-0")
					setTimeout(() => {
						middle.classList.replace("p-0", "p-1")
					}, 1000)
				})
				setTimeout(() => {
					this.setState({ textTop: "07 REGISTER YOUR INTEREST" })
				}, 500)
			} else {
				this.setState({ index: 0 }, () => {
					const scroll = document.querySelector(".scrollWrapper")
					scroll.style.transform = `translateY(-${100 * this.state.index}vh)`
					document.querySelector("#top-button").classList.replace("p-1", "p-0")
					setTimeout(() => {
						const message = this.state.mobile ? "Register" : "Register your Interest"
						this.setState({ text: message }, () => {
							arrow.classList.remove("top")
						})
						this.setState({ textTop: "01 WHERE HOME MATTERS" })
						//remove fadeout
					}, 500)
					setTimeout(() => {
						arrow.classList.remove("top")

						document.querySelector("#top-button").classList.replace("p-0", "p-1")
					}, 1000)

					const middle = document.querySelector("#middle-text")
					middle.classList.replace("p-1", "p-0")
					setTimeout(() => {
						middle.classList.replace("p-0", "p-1")
					}, 1000)
				})
			}
		} else {
			const bottomSection = document.querySelector("#form-section")
			const topSection = document.querySelector("#top-section")

			if (this.state.text === "Register") {
				bottomSection.scrollIntoView()
			} else {
				topSection.scrollIntoView()
			}
		}
	}

	loading = () => {
		//displys loading bar

		const percent = document.querySelector("#percent")
		setTimeout(() => {
			const loadingBar = document.querySelector("#loading-bar")
			const logo = document.querySelector("#logo")
			loadingBar.classList.add("loading")
			percent.classList.replace("beforeloading", "loading")
			logo.classList.replace("before-load", "loaded")

			setTimeout(() => {
				let i = 0
				let interval = setInterval(() => {
					if (i < 100) {
						i += 2
						this.setState({ loaded: i })
					} else {
						clearInterval(interval)
						setTimeout(() => {
							document.querySelectorAll(".data-title-text").forEach(el => {
								el.classList.replace("p-0", "p-1")
							})
						}, 750)
					}
				}, 3000 / 50)
			}, 500)
		}, 500)

		// displays percentage stops after 3s
	}

	changeTopBarColor = () => {
		const arrow = document.querySelector("#arrow")

		try {
			switch (this.state.index) {
				case 0:
					setTimeout(() => {
						this.setState({ textTop: "01 Where home matters" })
					}, 750)
					break

				case 3:
					setTimeout(() => {
						this.setState({ textTop: "04 Where views matter" })
					}, 750)
					break

				case 1:
					setTimeout(() => {
						this.setState({ textTop: "02 Where light matters" })
					}, 750)
					break

				case 2:
					setTimeout(() => {
						this.setState({ textTop: "03 Where aspect matters" })
					}, 750)
					break

				case 4:
					setTimeout(() => {
						this.setState({ textTop: "05 WHERE SPACE MATTERS" })
					}, 750)
					break

				case 5:
					setTimeout(() => {
						this.setState({ textTop: "06 Where environment matters" })
					}, 750)

					if (this.state.text === "back to top") {
						document.querySelector("#top-button").classList.replace("p-1", "p-0")

						setTimeout(() => {
							arrow.classList.remove("top")
							document.querySelector("#top-button").classList.replace("p-0", "p-1")
						}, 1000)

						setTimeout(() => {
							const message = this.state.mobile ? "Register" : "Register your Interest"

							this.setState({ text: message }, () => {
								arrow.classList.remove("top")
							})
						}, 500)
					}

					break

				case 6:
					setTimeout(() => {
						this.setState({ textTop: "07 Register Your Interest" })
					}, 750)

					document.querySelector("#top-button").classList.replace("p-1", "p-0")

					setTimeout(() => {
						this.setState({ text: "back to top" })
						arrow.classList.add("top")
						document.querySelector("#top-button").classList.replace("p-0", "p-1")
					}, 1000)
					break

				default:
					throw new Error("invalid section")
			}
		} catch (error) {
			console.error(error)
		}
	}

	//scrollling logic
	checkScrollDirection = e => {
		const scolling = e.deltaY
		const scroll = document.querySelector(".scrollWrapper")

		if (scolling > 0 && this.state.index !== 6) {
			this.setState({ index: this.state.index + 1 }, () => {
				this.changeTopBarColor()
			})
			const middle = document.querySelector("#middle-text")
			middle.classList.replace("p-1", "p-0")
			middle.classList.add("p-0")
			setTimeout(() => {
				middle.classList.replace("p-1-t", "p-5-t")
				middle.classList.replace("p-0", "p-1")
			}, 1000)

			scroll.style.transform = `translateY(-${100 * this.state.index}vh)`
			setTimeout(() => {
				window.addEventListener(
					"wheel",
					e => {
						this.checkScrollDirection(e)
					},
					{ once: true }
				)
			}, 1500)
		} else if (scolling < 0 && this.state.index !== 0) {
			this.setState({ index: this.state.index - 1 }, () => {
				this.changeTopBarColor()
				scroll.style.transform = `translateY(-${100 * this.state.index}vh)`
				const middle = document.querySelector("#middle-text")

				middle.classList.replace("p-1", "p-0")
				middle.classList.add("p-0")
				setTimeout(() => {
					middle.classList.replace("p-1-t", "p-5-t")
					middle.classList.replace("p-0", "p-1")
				}, 1000)
			})

			setTimeout(() => {
				window.addEventListener(
					"wheel",
					e => {
						this.checkScrollDirection(e)
					},
					{ once: true }
				)
			}, 1500)
		} else {
			window.addEventListener(
				"wheel",
				e => {
					this.checkScrollDirection(e)
				},
				{ once: true }
			)
		}
	}

	handleWaitlist = () => {
		const scroll = document.querySelector(".scrollWrapper")
		this.setState({ formType: "rental" })
		this.setState({ index: 6 }, () => {
			if (this.state.mobile) {
				const bottomSection = document.querySelector("#form-section")
				const topSection = document.querySelector("#top-section")
				if (this.state.text === "Register") {
					bottomSection.scrollIntoView()
				} else {
					topSection.scrollIntoView()
				}
			} else {
				this.changeTopBarColor()
				scroll.style.transform = `translateY(-${100 * this.state.index}vh)`
			}
		})
	}

	render() {
		return (
			<Layout>
				<SEO title='Bide' />
				<Loader loaded={this.state.loaded} />
				<Header textTop={this.state.textTop} handleClick={this.handleLink} text={this.state.text} toForm={true} />
				<div className='scrollWrapper' id='scrollWrapper'>
					<div className='h-100vh re p-t-110 flex flex-c  flex-sb' id='top-section'>
						<div className='flex flex-c ju-c al-c p-r-20 p-l-20'>
							<h1 className='z-4 re p-0 p-1-t-t m-b-40 data-title-text px96'>Now Renting</h1>
							<h2 className='size-18px re white z-100 t-c p-0 p-1-t-t data-title-text' style={{ fontWeight: "400", fontSize: "21px", lineHeight: "150%" }}>
								Construction Completing 2023
							</h2>
						</div>
						<div className='flex flex-r ju-c p-b-40'>
							<div className='flex flex-wrap justify-center flex-c align-center'>
								<h2 className='size-18px re white z-100 t-c p-0 p-1-t-t data-title-text w-100p' style={{ fontWeight: "400", fontSize: "21px", lineHeight: "150%" }}>
									Join the Bide Rental Waitlist. Inspections to commence October 2023.
								</h2>
								<div className={`waitlist mb40 ${this.state.loaded === 100 ? "loaded" : " "}`} onClick={this.handleWaitlist}>
									<button>Join the waitlist</button>
								</div>
								<svg width='84' height='50' viewBox='0 0 84 50' fill='none' className='p-0 p-1-t-t z-100 data-title-text' xmlns='http://www.w3.org/2000/svg'>
									<path
										d='M14.4726 7.492L15.3966 10H16.5846L13.4766 1.648H12.1206L9.14461 10H10.2486L11.1486 7.492H14.4726ZM11.4366 6.544C12.0726 4.672 12.5646 3.256 12.7686 2.548H12.7806C12.9606 3.184 13.3926 4.348 14.1966 6.544H11.4366ZM22.2856 12.388V9.244C22.5616 9.736 23.0776 10.144 24.0616 10.144C25.5376 10.144 26.7016 8.98 26.7016 6.796C26.7016 4.948 25.6816 3.772 24.2776 3.772C23.2336 3.772 22.6216 4.252 22.2856 4.876C22.2856 4.48 22.2736 4.12 22.2496 3.916H21.2296C21.2416 4.384 21.2416 4.9 21.2416 5.404V12.388H22.2856ZM25.6216 6.844C25.6216 8.344 25.0336 9.256 23.9176 9.256C22.6456 9.256 22.2376 8.38 22.2376 6.952C22.2376 5.464 22.7416 4.672 24.0016 4.672C25.0336 4.672 25.6216 5.548 25.6216 6.844ZM28.3254 10H29.3814V7.048C29.3814 5.512 30.1734 4.852 31.4214 4.816V3.772C30.4134 3.796 29.6934 4.336 29.3814 5.152C29.3814 4.564 29.3574 4.084 29.3454 3.916H28.3134C28.3134 4.24 28.3254 4.72 28.3254 5.572V10ZM35.1264 3.772C33.2904 3.772 32.2584 5.164 32.2584 6.964C32.2584 8.8 33.3144 10.144 35.0544 10.144C36.9144 10.144 37.9224 8.704 37.9224 6.94C37.9224 5.032 36.8184 3.772 35.1264 3.772ZM35.0784 4.648C36.2184 4.648 36.8424 5.596 36.8424 6.964C36.8424 8.344 36.2064 9.268 35.1024 9.268C34.0104 9.268 33.3384 8.296 33.3384 6.952C33.3384 5.572 33.9384 4.648 35.0784 4.648ZM39.6101 3.916V10.384C39.6101 11.236 39.5021 11.608 38.7701 11.608C38.7101 11.608 38.6141 11.608 38.5421 11.596V12.484C38.6381 12.496 38.8781 12.508 38.9501 12.508C40.2701 12.508 40.6661 11.884 40.6661 10.204V3.916H39.6101ZM40.6661 2.5V1.192H39.6101V2.5H40.6661ZM47.6177 7.144C47.6297 6.988 47.6297 6.832 47.6297 6.64C47.6297 5.344 46.9937 3.772 45.0257 3.772C43.1777 3.772 42.2657 5.212 42.2657 7.024C42.2657 8.584 43.0457 10.144 44.9537 10.144C46.6217 10.144 47.2817 9.1 47.5217 8.32H46.4537C46.2617 8.764 45.9497 9.268 44.9897 9.268C43.9577 9.268 43.3337 8.38 43.3217 7.144H47.6177ZM43.3577 6.412C43.4657 5.344 43.9337 4.6 45.0137 4.6C46.0457 4.6 46.5497 5.404 46.5617 6.412H43.3577ZM53.0453 8.14C52.7933 8.86 52.3493 9.268 51.5933 9.268C50.5373 9.268 49.9493 8.344 49.9493 6.952C49.9493 5.572 50.5613 4.648 51.6293 4.648C52.5173 4.648 52.9013 5.188 53.0453 5.8H54.0893C54.0173 5.02 53.4053 3.772 51.6533 3.772C49.8413 3.772 48.8693 5.272 48.8693 6.988C48.8693 8.944 49.9013 10.144 51.5813 10.144C53.1293 10.144 53.8373 9.184 54.0893 8.14H53.0453ZM54.9368 4.768H55.9928V8.584C55.9928 9.592 56.4008 10.084 57.3488 10.084C57.6488 10.084 58.0088 10.072 58.2608 9.976V9.184C58.0928 9.22 57.8768 9.232 57.7328 9.232C57.1808 9.232 57.0368 8.932 57.0368 8.332V4.768H58.3808V3.916H57.0368V2.116H55.9928V3.916H54.9368V4.768ZM63.064 7.96C63.064 8.632 63.064 9.316 63.052 10H64.06C64.084 9.832 64.108 9.508 64.108 9.196C64.408 9.784 64.924 10.144 65.896 10.144C67.612 10.144 68.548 8.68 68.548 6.832C68.548 5.032 67.588 3.772 66.052 3.772C64.948 3.772 64.384 4.264 64.12 4.78V1.192H63.064V7.96ZM67.468 6.856C67.468 8.332 66.832 9.256 65.752 9.256C64.468 9.256 64.06 8.248 64.06 6.976C64.06 5.524 64.516 4.66 65.812 4.66C66.868 4.66 67.468 5.536 67.468 6.856ZM69.438 3.916L71.718 10.24C71.358 11.248 71.07 11.584 70.302 11.584C70.134 11.584 69.954 11.572 69.798 11.56V12.472C70.038 12.496 70.266 12.508 70.458 12.508C71.694 12.508 72.162 12.064 72.774 10.276L74.958 3.916H73.902C72.906 6.976 72.474 8.368 72.282 9.064H72.27C72.102 8.44 71.562 6.832 70.578 3.916H69.438Z'
										fill='#F2F2F0'
									/>
									<path
										d='M3.81407 35.5825C3.11076 36.3152 2.73206 37.3357 2.73206 38.6178C2.73206 39.9 3.08371 40.9204 3.81407 41.6531C4.51737 42.3857 5.49118 42.7521 6.68138 42.7521C7.43878 42.7521 8.11504 42.5689 8.71014 42.2287C9.30524 41.8886 9.76509 41.4176 10.1167 40.7896C10.4684 40.1616 10.6307 39.429 10.6307 38.6178C10.6307 37.8067 10.4684 37.074 10.1167 36.446C9.76509 35.818 9.30524 35.3209 8.71014 34.9807C8.11504 34.6406 7.43878 34.4574 6.68138 34.4574C5.49118 34.4836 4.51737 34.8499 3.81407 35.5825ZM8.84539 33.0444C9.68394 33.5939 10.252 34.3527 10.5766 35.2686V27.2617H13.2816V44.8977H10.5766V41.9932C10.252 42.9091 9.65689 43.6679 8.84539 44.2174C8.03389 44.7669 7.03303 45.0547 5.84283 45.0547C4.70672 45.0547 3.70587 44.793 2.81321 44.2697C1.92056 43.7464 1.24431 43.0137 0.730353 42.0456C0.243451 41.0774 0 39.9523 0 38.6178C0 37.3095 0.243451 36.1844 0.757403 35.2162C1.27136 34.2481 1.94761 33.5154 2.84026 32.9921C3.73292 32.4688 4.73377 32.2071 5.86988 32.2071C7.03303 32.2071 8.03389 32.4949 8.84539 33.0444Z'
										fill='#F2F2F0'
									/>
									<path d='M16.7168 30.5324C15.716 30.5324 14.9045 29.7474 14.9045 28.7793C14.8774 27.785 15.6889 27 16.7168 27C17.7177 27 18.5292 27.785 18.5292 28.7531C18.5292 29.7474 17.7177 30.5324 16.7168 30.5324ZM18.0423 44.8976H15.3643V32.3641H18.0423V44.8976Z' fill='#F2F2F0' />
									<path
										d='M24.7238 35.0069C24.1287 35.3471 23.6689 35.8442 23.3172 36.4722C22.9656 37.1002 22.8033 37.8328 22.8033 38.644C22.8033 39.4813 22.9656 40.2139 23.3172 40.8158C23.6689 41.4438 24.1287 41.9147 24.7238 42.2549C25.3189 42.5951 25.9952 42.7782 26.7526 42.7782C27.9428 42.7782 28.8895 42.4119 29.6199 41.6793C30.3502 40.9466 30.7019 39.9261 30.7019 38.644C30.7019 37.3618 30.3502 36.3675 29.6199 35.6087C28.8895 34.8761 27.9428 34.4836 26.7526 34.4836C25.9952 34.4836 25.3189 34.6667 24.7238 35.0069ZM30.5937 32.9921C31.4863 33.5154 32.1626 34.2481 32.6765 35.2162C33.1905 36.1844 33.434 37.3095 33.434 38.6178C33.434 39.9261 33.1905 41.0774 32.6765 42.0456C32.1626 43.0137 31.4863 43.7464 30.5937 44.2697C29.701 44.793 28.7002 45.0547 27.5641 45.0547C26.4009 45.0547 25.4001 44.7669 24.5615 44.2174C23.723 43.6679 23.1549 42.9091 22.8303 41.9932V44.8977H20.1523V27.2617H22.8303V35.2686C23.1549 34.3527 23.75 33.5939 24.5615 33.0444C25.4001 32.4949 26.4009 32.2071 27.5641 32.2071C28.7002 32.2071 29.701 32.4688 30.5937 32.9921Z'
										fill='#F2F2F0'
									/>
									<path
										d='M44.7682 33.4892C45.8773 34.3527 46.5535 35.504 46.824 36.9693H43.9837C43.8214 36.1843 43.4427 35.5563 42.8476 35.1115C42.2525 34.6666 41.4951 34.4312 40.5754 34.4312C39.5475 34.4312 38.6819 34.7713 37.9786 35.4778C37.3024 36.1843 36.9507 37.2048 36.9507 38.5916C36.9507 39.9522 37.3024 40.9989 37.9786 41.7053C38.6549 42.4118 39.5205 42.7781 40.5754 42.7781C41.4951 42.7781 42.2525 42.5427 42.8476 42.0978C43.4427 41.653 43.8214 41.025 43.9837 40.24H46.797C46.5265 41.7053 45.8502 42.8828 44.7411 43.7463C43.6321 44.6098 42.2525 45.0546 40.5754 45.0546C39.3311 45.0546 38.2221 44.7929 37.2483 44.2696C36.2745 43.7463 35.5171 43.0136 34.9761 42.0455C34.4351 41.0773 34.1646 39.926 34.1646 38.6177C34.1646 37.3094 34.4351 36.1843 34.9761 35.2161C35.5171 34.248 36.2745 33.5153 37.2483 32.992C38.2221 32.4687 39.3311 32.207 40.5754 32.207C42.2796 32.207 43.6591 32.6519 44.7682 33.4892Z'
										fill='#F2F2F0'
									/>
									<path
										d='M52.2609 34.9281C51.6929 35.2421 51.206 35.6869 50.8543 36.3149C50.5027 36.9429 50.3133 37.7017 50.3133 38.6175C50.3133 39.5333 50.5027 40.3183 50.8543 40.9463C51.206 41.5743 51.6658 42.0191 52.2609 42.3331C52.829 42.6471 53.4782 42.7779 54.1544 42.7779C54.8307 42.7779 55.4799 42.6209 56.0479 42.3331C56.616 42.0191 57.1029 41.5743 57.4545 40.9463C57.8062 40.3183 57.9955 39.5595 57.9955 38.6175C57.9955 37.7017 57.8062 36.9429 57.4545 36.3149C57.1029 35.6869 56.643 35.2159 56.0479 34.9281C55.4799 34.6141 54.8307 34.4833 54.1544 34.4833C53.4782 34.4571 52.829 34.6141 52.2609 34.9281ZM57.5357 32.9918C58.5365 33.5151 59.321 34.2478 59.889 35.2159C60.4571 36.1841 60.7276 37.3092 60.7276 38.6175C60.7276 39.9258 60.4571 41.0771 59.889 42.0453C59.321 43.0134 58.5365 43.7461 57.5357 44.2694C56.5348 44.7927 55.3987 45.0544 54.1544 45.0544C52.9101 45.0544 51.774 44.7927 50.7732 44.2694C49.7723 43.7461 48.9879 43.0134 48.4198 42.0191C47.8517 41.051 47.5542 39.8997 47.5542 38.5914C47.5542 37.2831 47.8517 36.1579 48.4198 35.1898C48.9879 34.2216 49.7723 33.489 50.7732 32.9656C51.774 32.4423 52.8831 32.1807 54.1544 32.1807C55.4258 32.2068 56.5348 32.4685 57.5357 32.9918Z'
										fill='#F2F2F0'
									/>
									<path d='M66.516 32.8871C67.3275 32.4162 68.2743 32.1807 69.3292 32.1807V35.0066H68.5177C67.3546 35.0066 66.4078 35.2944 65.6775 35.8439C64.9741 36.3934 64.5954 37.3092 64.5954 38.5914V44.9236H61.9175V32.3638H64.5954V34.8234C65.0823 34.0123 65.7045 33.3581 66.516 32.8871Z' fill='#F2F2F0' />
									<path
										d='M77.2008 42.7781C78.391 42.7781 79.3378 42.4118 80.0681 41.653C80.7985 40.9204 81.1501 39.8999 81.1501 38.6177C81.1501 37.3356 80.7985 36.3151 80.0681 35.5825C79.3378 34.8498 78.391 34.4835 77.2008 34.4835C76.4434 34.4835 75.7672 34.6666 75.1721 35.0068C74.577 35.347 74.1171 35.818 73.7655 36.4459C73.4138 37.0739 73.2515 37.8066 73.2515 38.6177C73.2515 39.4289 73.4138 40.1615 73.7655 40.7895C74.1171 41.4175 74.577 41.9147 75.1721 42.2548C75.7942 42.6211 76.4705 42.7781 77.2008 42.7781ZM78.0394 45.0546C76.8762 45.0546 75.8754 44.7668 75.0368 44.2173C74.1982 43.6678 73.6302 42.909 73.3056 41.9932V50H70.6006V32.364H73.2785V35.2685C73.6031 34.3527 74.1982 33.5938 75.0098 33.0443C75.8483 32.4949 76.8492 32.207 78.0123 32.207C79.1484 32.207 80.1493 32.4687 81.0419 32.992C81.9346 33.5153 82.6108 34.248 83.1248 35.2161C83.6387 36.1843 83.8822 37.3356 83.8822 38.6439C83.8822 39.9522 83.6387 41.0773 83.1248 42.0455C82.6108 43.0136 81.9346 43.7463 81.0419 44.2696C80.1763 44.7929 79.1755 45.0546 78.0394 45.0546Z'
										fill='#F2F2F0'
									/>
								</svg>
							</div>
						</div>
						<StaticImage src='../images/2-Bide-SUPERMAN-2.jpg' className='ab h-100p w-100p z-3 t-0' imgStyle={{ filter: "brightness(0.9)" }} alt='' loading='eager' />
					</div>
					<Section100 className='p-t-170  p-r-115 p-l-115 '>
						<div className='h-100p flex flex-c'>
							<div className='ov-h h-100p re pos-rel'>
								<StaticImage quality={100} loading='eager' src='../images/IMAG2.jpg' className='w-100p br-90 h-100p' objectFit='cover' alt='' />
							</div>
							<div className='h-170 flex flex-r ju-c' />
						</div>
					</Section100>

					<div className='section-100vh split'>
						<div className='split-child center  ' style={{ backgroundColor: "#ACAB9A" }}>
							<div className='flex flex-c ju-c al-c'>
								<h1 className='George medium cream mar-32'>
									Elevated Living <br /> with City Views
								</h1>
							</div>
						</div>
						<div className='split-child  center re'>
							<StaticImage loading='eager' src='../images/image1.jpg' className='ab w-100p h-100p z-3' alt='' imgStyle={{ filter: "brightness(0.95" }} />
							<div className='text-center z-4' style={{ transform: "translate3d(0, 0, 0)" }}></div>
						</div>
					</div>
					<Section100>
						<StaticImage loading='eager' src='../images/image111.jpg' className='h-100p w-100p ab' alt='' />
					</Section100>

					<Section100 className='p-t-170 br-h-u p-b-170 p-r-115 p-l-115'>
						<div className='ov-h h-100p re'>
							<StaticImage loading='eager' src='../images/Bath.jpg' className='w-100p h-100p' objectFit='cover' alt='' />
						</div>
					</Section100>
					<Section100>
						<div className='pos-rel h-100p'>
							<StaticImage loading='eager' src='../images/13-Bide-GREENSPACE_C_.jpg' className='h-100p w-100p ab' alt='' imgStyle={{ filter: "brightness(0.95" }} />
							<div className='bottom-caption Acuman-lowercase'>
								<br /> Construction completing late 2023.
							</div>
						</div>
					</Section100>

					{/* form section */}
					<div id='form-section' className='section-100vh padding-190px form-section' style={{ backgroundColor: "hsla(57, 10%, 64%, 1)" }}>
						<div>
							<div className='pad-20-b'>
								<h4 className='text white'>INFORMATION</h4>
							</div>
							<div>
								<p className='Acuman-lowercase white weight-400'>
									17-21 Longland Street, Newstead Q 4006
									<br />
									By private appointment only.
									<br />
									propertymanager@dmst.com.au | 0477 800 277
								</p>
							</div>
							<div className='pad-20-b mt40'>
								<h4 className='text white'>ENQUIRY TYPE</h4>
							</div>
							<div className='form--switcher'>
								<button
									onClick={() => {
										if (this.state.formType !== "sales") {
											this.setState({ formType: "sales" })
										}
									}}
									className={`${this.state.formType === "sales" ? "active" : " "}`}
								>
									Sales
								</button>
								<button
									onClick={() => {
										if (this.state.formType !== "rental") {
											this.setState({ formType: "rental" })
										}
									}}
									className={`${this.state.formType === "rental" ? "active" : " "}`}
								>
									Rentals
								</button>
							</div>
						</div>
						<div className='form-wrapper'>
							<div className='form'>
								<div id='form-sales' className={`hubspot-form form-sales form-inner ${this.state.formType === "sales" ? "visible" : "none"}`} />
								<div id='form-rental' className={`hubspot-form form-rental form-inner overflow ${this.state.formType === "rental" ? "visible" : "none"}`}>
									<RentalForm />
								</div>
							</div>
						</div>
						<Footer />
					</div>
				</div>
			</Layout>
		)
	}
}

export default IndexPage
